import {Lesson} from './lesson.model';

export interface CourseSection {
  id:string;
  courseId: string;
  seqNo: number;
  title: string;
  lock?: boolean;
}


export function calculateSectionLessons(section: CourseSection, allCourseLessons: Lesson[]) {

  if (!section) {
    return {sectionLessons: [], sectionStartIndex: 0};
  }

  const findBySectionId = lesson => lesson.sectionId == section.id;

  const publishedLessons = allCourseLessons.filter(lesson => lesson.status == 'published');

  const sectionLessons = publishedLessons.filter(findBySectionId);

  const sectionStartIndex = publishedLessons.findIndex(findBySectionId);

  return {
    sectionLessons,
    sectionStartIndex
  };

}
